// A date of birth is a calendar date: show it as entered. '1990-03-04' is
// 04/03/1990 — never through new Date(), which reads a bare date as UTC
// midnight and shows the day before in Guyana (the bug the printed report
// already had fixed). Anything that isn't YYYY-MM-DD is shown as stored.
export const formatDob = (dob) => {
    if (!dob) return '-';
    const m = String(dob).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : String(dob);
};
